


















import Debug from 'debug';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { delay } from '@/app/shared/utils/delay';
import { EventStream, EventStreamSymbol } from '@/app/event-stream';
import i18n from '@/plugins/i18n'
import ToastNotificationComponent from './toast-notification-component.vue';
import { NotificationStoreModule, NotificationStoreModuleSymbol, Notification, NotificationPhase} from '../store'
import { NotificationService, NotificationServiceSymbol } from '../service'
import { NotificationCloseable } from '../api'
import * as BadgeNotifications from '@/app/badge/notification'
import * as TrackingNotifications from '@/app/tracking/notification';
import * as FetchNotifications from '@/app/fetch/notification';

const debug = Debug('badge-earned-notification-component');

interface UiItem {
  id: string
  type: 'badges' | 'error' | 'warning' | 'success' | 'general',
  title: string,
  message: string
  badgeName?: string
  imageUri?: string
  phase: NotificationPhase
  closeable: NotificationCloseable
}

type HandledNotification = Notification<'badge-earned', BadgeNotifications.BadgeEarnedNotificationPayload> |
      Notification<'temporary-tracking-error', TrackingNotifications.TemporaryTrackingErrorNotificationPayload> |
      Notification<'compatibility-tracking-error', TrackingNotifications.CompatibilityTrackingErrorNotificationPayload> |
      Notification<'fatal-tracking-error', TrackingNotifications.FatalTrackingErrorNotificationPayload> |
      Notification<'temporary-fetch-error', FetchNotifications.TemporaryFetchErrorNotificationPayload>


@Component({
    components: {
      ToastNotificationComponent
    }
  })
export default class NotificationComponent extends Vue {

  @lazyInject(NotificationStoreModuleSymbol)
  private store: NotificationStoreModule;

  @lazyInject(NotificationServiceSymbol)
  private service: NotificationService;

  private get notifications() {
    return this.store.notifications.map(x => this.mapNotification(x as HandledNotification))
  }

  // In the future it might be worth it to create pluginized architecture, for now, from the GUI level
  // it is hardcoded
  private mapNotification(notification: HandledNotification): UiItem {

    const common = {
      phase: notification.phase,
      closeable: notification.options.closeable
    }

    switch (notification.type) {
      case 'badge-earned':
        {
          const badge = notification.payload.badge

          return {
            id: notification.id,
            type: 'badges',
            title: i18n.t('badge.badge_earned_notification.title').toString(),
            message: badge.description,
            badgeName: badge.name,
            imageUri: badge.imageUri,
            ...common
          }
        }
      case 'compatibility-tracking-error':
      case 'temporary-tracking-error': {

        const payload = notification.payload

        return {
          id: notification.id,
          type: 'warning',
          title: payload.title,
          message: payload.message,
          ...common
        }
      }


      case 'fatal-tracking-error': {

        const payload = notification.payload

        return {
          id: notification.id,
          type: 'error',
          title: payload.title,
          message: payload.message,
          ...common
        }
      }

      case 'temporary-fetch-error': {

        const payload = notification.payload

        return {
          id: notification.id,
          type: 'warning',
          title: payload.title,
          message: payload.message,
          ...common
        }
      }

    }

    throw new Error(`Coding error: visualization not found for notification '${JSON.stringify(notification)}'`);
  }

  public handleClose(id: string): void {
    this.service.hide(id)
  }
}
